export default "__VITE_PUBLIC_ASSET__4d094fc1__"